import $ from "jquery";

const productCategory = () => {
  const init = () => {
    execute();
  };

  const execute = () => {
    const el = {
      image: ".mi-category-product ul.products .product-category a img",
      linkElement: ".mi-category-product ul.products .product-category a",
      listCategory: ".mi-category-product ul.products .product-category",
    };

    const newDiv = $('<div class="wrapper-img-category"></div>');

    $(el.linkElement).append(newDiv);

    $(el.linkElement).each(function () {
      const newDiv = $(this).find("div");
      const image = $(this).find("img");

      newDiv.append(image);
    });
  };

  init();
};

try {
  productCategory();
} catch (error) {
  console.log(error);
}
